import carecentreTokens from "./tokens";

const toPx = (value) => Number.parseInt(value, 10);

/** Numeric px values derived from tokens — for makeStyles / MUI pilot components. */
export const carecentreTypeScale = Object.fromEntries(
  Object.entries(carecentreTokens.type).map(([name, style]) => [
    name,
    {
      fontSize: toPx(style.fontSize),
      lineHeight: toPx(style.lineHeight),
      fontWeight: style.fontWeight,
    },
  ]),
);

export default carecentreTypeScale;
